module.exports = __webpack_public_path__ + "img/title2.520a1cc4.png";